import { useState } from "react";

import type {
  BondsProject,
  Simulator,
} from "@tudigo-monorepo/core-tudigo-api-models";
import { formatCurrency } from "@tudigo-monorepo/core-tudigo-utils";
import { useComparator } from "@tudigo-monorepo/web-tudigo-comparator";
import {
  ButtonRebrand,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogSeparator,
  DialogTitle,
} from "@tudigo-monorepo/web-tudigo-components";
import { UI_PROJECTS_COMPARATOR_REPAYMENT_TABLE_VIEW } from "@tudigo-monorepo/web-tudigo-tracking";

import { ProjectSimulatorBondsRepayments } from "../../../../../../shared-external/components/project-simulator-bonds-repayments";
import { useProjectsComparatorCustomerTracking } from "../../../../hooks/use-projects-comparator-customer-tracking";

export function ProjectsComparatorSimulatorRepaymentsModal({
  project,
  simulatorData,
}: {
  project: BondsProject;
  simulatorData: Simulator | undefined;
}) {
  const { urlState } = useComparator();
  const simulatorAmount = urlState.amount;
  const [isOpen, setIsOpen] = useState(false);
  const { customerTrackComparator } = useProjectsComparatorCustomerTracking();

  return (
    <>
      <ButtonRebrand
        variant="ghost"
        className="text-black-primary underline hover:bg-transparent"
        onClick={() => {
          setIsOpen(true);
          customerTrackComparator(UI_PROJECTS_COMPARATOR_REPAYMENT_TABLE_VIEW, {
            project_id: project.id,
            comparator_amount: simulatorAmount,
          });
        }}
      >
        Voir l’échéancier
      </ButtonRebrand>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              Échéancier {project.content?.name ?? ""}
              {simulatorAmount !== null &&
                ` - Investissement ${formatCurrency(simulatorAmount * 100)}`}
            </DialogTitle>
          </DialogHeader>
          <DialogSeparator />
          <ProjectSimulatorBondsRepayments data={simulatorData} />
        </DialogContent>
      </Dialog>
    </>
  );
}
